module.exports = __webpack_public_path__ + "img/jp.db1e3fb2.svg";